import { Grid, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import { temperatureCardStyles } from "./TemperatureCardStyles";
import { ReactComponent as CircleRedCircleXMarkIcon } from "icons/CircleRedCircleXMarkIcon.svg";
import { ReactComponent as CircleGreenIconCircle } from "icons/CircleGreenIconCircle.svg";
import { numberAfterDotCounter } from "helpers/numberAfterDotCounter";
import { TempCardProps } from "./TempCardProps";
import { pluralize } from "helpers/pluralize";

export default observer(function TemperatureCard({ excursionType, rsb, lowerLimit, upperLimit }: TempCardProps) {
    const classes = temperatureCardStyles();

    return (
        <div className={classes.card}>
            <Grid container spacing={2}>
                <Grid item>{rsb >= 0 || rsb === null ? <CircleGreenIconCircle /> : <CircleRedCircleXMarkIcon />}</Grid>
                <Grid item xs={6}>
                    <Typography className={classes.type}>Temperature Band: {excursionType}</Typography>
                    <Typography className={classes.plain}>Total remaining stability time</Typography>
                    <Typography className={classes.hours}>
                        {rsb !== null
                            ? numberAfterDotCounter(rsb) + " " + pluralize("hour", numberAfterDotCounter(rsb))
                            : "Same as product expiry"}
                    </Typography>
                    <Typography className={classes.temp}>
                        Temp Range:{" "}
                        {lowerLimit === null
                            ? "< " + numberAfterDotCounter(upperLimit) + "°C"
                            : upperLimit === null
                            ? "> " + numberAfterDotCounter(lowerLimit) + "°C"
                            : numberAfterDotCounter(lowerLimit) + "°C to " + numberAfterDotCounter(upperLimit) + "°C"}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
});
